import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { Team } from "@common/ADAPT.Common.Model/organisation/team";
import { ArrayUtilities } from "@common/lib/utilities/array-utilities";
import { IDxListSelectionChangedEvent } from "@common/ux/dx.types";
import ArrayStore from "devextreme/data/array_store";
import DataSource from "devextreme/data/data_source";
import { CommonTeamsService } from "../common-teams.service";

@Component({
    selector: "adapt-select-teams",
    templateUrl: "./select-teams.component.html",
    styleUrls: ["./select-teams.component.scss"],
    standalone: false,
})
export class SelectTeamsComponent implements OnInit {
    @Input() public filter?: (team: Team | null) => boolean;
    @Input() public showOrganisation = true;
    @Input() public singleSelection = false;
    @Output() public teamsSelectedChange = new EventEmitter<(Team | null)[]>();

    public dataSource?: DataSource;
    private selectedItems: (Team | null)[] = [];

    public constructor(
        private teamsService: CommonTeamsService,
    ) { }

    public async ngOnInit() {
        const teams: (Team | null)[] = await this.teamsService.promiseToGetAllActiveTeams();
        if (this.showOrganisation) {
            teams.unshift(null);
        }
        teams.sort((a, b) => {
            if (a === null) return -1;
            if (b === null) return 1;
            return a.name.localeCompare(b.name);
        });
        this.dataSource = new DataSource({
            store: new ArrayStore({
                data: teams,
                key: "teamId",
            }),
            sort: "name",
            filter: this.filter,
        });
    }

    public onSelectionChanged(e: IDxListSelectionChangedEvent<Team>) {
        if (e.addedItems?.length) {
            ArrayUtilities.addElementIfNotAlreadyExists(this.selectedItems, ...e.addedItems);
        }

        if (e.removedItems?.length) {
            e.removedItems.forEach((removedItem) => ArrayUtilities.removeElementFromArray(removedItem, this.selectedItems));
        }

        this.teamsSelectedChange.emit(this.selectedItems);
    }

    public searchTeamFunction = (team: Team | null) => {
        return team?.name ?? "Organisation";
    };
}
